import { useContext } from 'react';

import { SynchronizedSelectionContext } from '../contexts/SynchronizedSelectionContext.js';

/**
 * @internal
 */
export const useSynchronizedSelection = () =>
  useContext(SynchronizedSelectionContext);
